"use client";

import { useSelectedLayoutSegments } from "next/navigation";
import type { MouseEvent } from "react";
import { localeMeta, locales, type Locale } from "@/i18n/config";
import { switchPath } from "@/i18n/routes";
import { useAlternateLinks } from "./alternate-links";

// TR/EN dil değiştirici: aynı sayfanın diğer dildeki karşılığına gider (karşılığı yoksa o dilin ana sayfasına).
// Yol, kök düzenin altındaki iç (Türkçe) parçalardan hesaplanır; bu değer sunucu ve tarayıcıda aynıdır
// (proxy yeniden yazmasında usePathname farklı olabilir → hidrasyon uyumsuzluğu olmaz).
// Dil değişimi tam sayfa yüklemesidir (<html lang> ve tüm metinler değişir); sorgu metni (?kalkis=…) korunur.
export function LanguageSwitcher({ locale, label }: { locale: Locale; label: string }) {
  const segments = useSelectedLayoutSegments();
  // Site Yönetimi sayfaları dildeki karşılığını kendisi bildirir (adresler panelden gelir)
  const alternates = useAlternateLinks();
  const keepQuery = (e: MouseEvent<HTMLAnchorElement>) => {
    if (window.location.search) e.currentTarget.href = e.currentTarget.pathname + window.location.search;
  };
  return (
    <nav aria-label={label}>
      <ul className="flex items-center rounded-full p-0.5 text-xs font-bold ring-1 ring-line-strong">
        {locales.map((l) => {
          const active = l === locale;
          return (
            <li key={l}>
              {active ? (
                <span aria-current="true" lang={localeMeta[l].htmlLang} title={localeMeta[l].label} className="inline-flex h-10 min-w-11 items-center justify-center rounded-full bg-primary px-2 text-on-primary">
                  {localeMeta[l].short}
                  <span className="sr-only"> — {localeMeta[l].label}</span>
                </span>
              ) : (
                <a
                  href={alternates?.[l] ?? switchPath(segments, l)}
                  hrefLang={localeMeta[l].htmlLang}
                  lang={localeMeta[l].htmlLang}
                  title={localeMeta[l].label}
                  onClick={keepQuery}
                  className="inline-flex h-10 min-w-11 items-center justify-center rounded-full px-2 text-ink hover:bg-primary-soft"
                >
                  {localeMeta[l].short}
                  <span className="sr-only"> — {localeMeta[l].label}</span>
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
